import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const Ctx = createContext(null);

export function EntitlementsProvider({ children }) {
  const { user } = useAuth();
  const [features, setFeatures] = useState([]);
  const [tier, setTier] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!user) { setLoading(false); return; }
    try {
      const { data } = await api.get("/billing/entitlements");
      setFeatures(data.features || []);
      setTier(data.tier || null);
    } catch (e) {
      // fail open — never block the app if billing layer is unavailable
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const entitled = useCallback((key) => {
    if (user?.role === "super_admin") return true;
    const f = features.find((x) => x.key === key);
    return f ? !!f.entitled : true; // unknown feature → not gated
  }, [features, user]);

  return (
    <Ctx.Provider value={{ features, tier, loading, refresh, entitled }}>
      {children}
    </Ctx.Provider>
  );
}

export function useEntitlements() {
  const c = useContext(Ctx);
  if (!c) throw new Error("useEntitlements must be used within EntitlementsProvider");
  return c;
}
